import React, { useEffect, useRef, useState } from 'react';
import { loadGoogleMapsApi } from './loadGoogleMapsApi';

const AddressAutoComplete = ({ apiKey, onPlaceSelected }) => {
    const containerRef = useRef(null);
    const [autocompleteSuggestion, setAutocompleteSuggestion] = useState(null);
    const [placesService, setPlacesService] = useState(null);
    const [inputValue, setInputValue] = useState("");
    const [suggestions, setSuggestions] = useState([]);

    // Load Google Maps script and create services
    useEffect(() => {
        loadGoogleMapsApi(apiKey)
            .then(() => {
                const suggestionService = new window.google.maps.places.AutocompleteSuggestion();
                setAutocompleteSuggestion(suggestionService);

                const placeService = new window.google.maps.places.PlacesService(
                    containerRef.current
                );
                setPlacesService(placeService);
            })
            .catch((error) => {
                console.error("Error loading Google Maps API:", error);
            });
    }, [apiKey]);

    // Fetch predictions on input change
    const handleChange = (e) => {
        const val = e.target.value;
        setInputValue(val);

        if (!autocompleteSuggestion || val.length < 2) {
            setSuggestions([]);
            return;
        }

        autocompleteSuggestion.getPredictions(
            { input: val, types: ["address"] },
            (predictions, status) => {
                if (
                    status === window.google.maps.places.PlacesServiceStatus.OK &&
                    predictions
                ) {
                    setSuggestions(predictions);
                } else {
                    setSuggestions([]);
                }
            }
        );
    };

    // When user selects a suggestion, get full place details
    const handleSelect = (suggestion) => {
        if (!placesService) return;

        placesService.getDetails(
            {
                placeId: suggestion.place_id,
                fields: ["formatted_address", "geometry", "address_components"],
            },
            (place, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                    onPlaceSelected?.({
                        address: place.formatted_address,
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng(),
                        components: place.address_components,
                    });
                    setInputValue(place.formatted_address);
                    setSuggestions([]);
                }
            }
        );
    };

    return (
        <div
            ref={containerRef}
            style={{ position: "relative", width: "100%", maxWidth: 400 }}
        >
            <input
                type="text"
                value={inputValue}
                onChange={handleChange}
                placeholder="Enter address"
                style={{ width: "100%", padding: 10, fontSize: 16 }}
            />
            {suggestions.length > 0 && (
                <ul
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        margin: 0,
                        padding: 0,
                        listStyle: "none",
                        zIndex: 1000,
                        maxHeight: 200,
                        overflowY: "auto",
                    }}
                >
                    {suggestions.map((s) => (
                        <li
                            key={s.place_id}
                            onClick={() => handleSelect(s)}
                            style={{
                                padding: "10px",
                                cursor: "pointer",
                                borderBottom: "1px solid #eee",
                            }}
                        >
                            {s.description}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default AddressAutoComplete